export default {
  root: {
    class: [
      // Sizing and Shape
      'min-w-[16rem] bg-white text-sm',
      'rounded-lg',
      // Spacing
      'pb-2',
      // Colors
      'bg-neutral-0 dark:bg-neutral-700',
      'text-neutral-700 dark:text-white/80',
      'shadow-xl border border-neutral-200 dark:border-neutral-700'
    ]
  },
  menu: {
    class: [
      // Spacings and Shape
      'list-none',
      'm-0',
      'p-0',
      'outline-none'
    ]
  },
  content: ({ context }) => ({
    class: [
      //Shape
      'rounded-none',
      // Colors
      'text-neutral-700 dark:text-white/80',
      {
        'bg-neutral-200 text-neutral-700 dark:bg-neutral-300/10 dark:text-white': context.focused
      },
      // Transitions
      'transition-shadow',
      'duration-200',
      // States
      'hover:text-neutral-700 dark:hover:text-white/80',
      'hover:bg-neutral-100 dark:bg-neutral-700 dark:hover:bg-neutral-400/10'
    ]
  }),
  action: {
    class: [
      'relative',
      // Flexbox

      'flex',
      'items-center',

      // Spacing
      'py-3',
      'px-5',

      // Color
      'text-neutral-700 dark:text-white/80',

      // Misc
      'no-underline',
      'overflow-hidden',
      'cursor-pointer',
      'select-none'
    ]
  },
  icon: {
    class: [
      // Spacing
      'mr-2',

      // Color
      'text-neutral-600 dark:text-white/70'
    ]
  },
  label: {
    class: ['leading-none']
  },
  submenuheader: {
    class: [
      // Font
      'font-bold',
      // Spacing
      'm-0',
      'py-3 px-5',
      // Shape
      'rounded-tl-none',
      'rounded-tr-none',
      // Colors
      'bg-neutral-0 dark:bg-neutral-700',
      'text-neutral-700 dark:text-white'
    ]
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass:
      'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0'
  }
}
